import alert from './main.vue';
alert.install = function(Vue) {
    Vue.component(alert.name, alert);
};
export default alert;